import React from 'react'
import { Grid, Icon } from 'semantic-ui-react'

import { Menu, Footer } from '@niimko/drupal_menu'

import { HeaderComponent } from '@/components/Header';
import { BodyComponent } from './Body';
import ThemeContext, { themes } from '@/theme/context'
import { Calltoaction } from '@/components/Calltoaction';
import { NewsComponent } from '@/components/News';
import { NormalHeader } from '../../main_page/components/style';
import { BackgroundImage, SliderContainer, TextDiv } from '@/components/Slider/style';

import { At, ThemedText, Email, Phone, FlexBlock } from './style';
import { Contacts } from '@/components/Contacts';

export const Olymp = (props) => {
    return (
        <ThemeContext.Provider value={themes.olymp}>
            <HeaderComponent {...props} currentAct="olymp"/>
            <Menu {...props}/>
            <SliderContainer>
                <BackgroundImage fluid src='/themes/olymp/images/slider.svg' />
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <TextDiv>
                                <FlexBlock><span><ThemedText><Icon name="phone" /></ThemedText><Phone href="tel:+78362422468">+7 8362 42-24-68</Phone></span></FlexBlock>
                                <ThemedText><At>@</At></ThemedText><Email href="mailto:nii.mko@yandex.ru">nii.mko@yandex.ru</Email>
                                <Contacts currentAct='olymp' color={themes.olymp.primaryColor} />
                            </TextDiv>
                            <TextDiv>
                                <NormalHeader>Олимпиады для студентов вузов и ссузов: региональные, всероссийские, международные</NormalHeader>
                            </TextDiv>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </SliderContainer>
            <BodyComponent {...props} />
            <Calltoaction {...props} />
            <Footer {...props}/>
        </ThemeContext.Provider>
    )
}
